import React from 'react';
import { PlayIconBtnBox, Video } from './style';
import { Box, useTheme } from '@mui/material';
import PlayIcon from '../../icons/PlayIcon';

/**
 * VideoListDetails - it shows list of video and info list
 *
 */
function VideoListDetails({
    url,
    videoDetails = {
        heading: 'Get the most out of Business Navigator',
        src: 'https://youtu.be/fGXYULMDpSk?si=hQyNzbrv7s0G0sUd',
        poster: '/images/avatars/avatar_1.jpga',
    },
}) {
    const theme = useTheme();

    const handleClick = (link) => {
        window.open(link, '_blank');
    };
    return (
        <>
            <Box
                sx={{
                    display: 'flex',

                    flexDirection: {
                        xs: 'column',
                        sm: 'row',
                    },
                }}
            >
                <Box
                    position={'relative'}
                    sx={{
                        width: {
                            xs: '100%',
                            sm: 'unset',
                        },

                        marginRight: {
                            xs: '0',
                            sm: theme.typography.generic.xLarge,
                        },
                        marginBottom: {
                            xs: theme.typography.generic.xLarge,
                            sm: '0',
                        },
                    }}
                >
                    <Video src={url} width="400"></Video>
                    <PlayIconBtnBox onClick={() => handleClick(url)} title="play button">
                        <PlayIcon />
                    </PlayIconBtnBox>
                </Box>
            </Box>
        </>
    );
}

export default VideoListDetails;
